<script>
import courses from '@/global/js/courses'
export default {
  name: 'StudentDetails',
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      student: {},
      guardian: {},
      scholarshipApp: [],
      invoices: [],
      classes: [],
      courses,
    }
  },
  methods: {
    async getDetails () {
      this.guardian = (await this.$firestore.collection('users').doc(this.student.guardian_id).get()).data()
      console.log('get guardian')
      this.scholarshipApp = (await this.$firestore.collection('scholarship_applications').where('guardian_id','==',this.student.guardian_id).get()).docs.map(doc => doc.data())
      this.invoices = (await this.$firestore.collection('invoices').where('guardian_id', '==', this.student.guardian_id).get()).docs.map(doc => doc.data())
      this.classes = this.options.classes
    },
    getNumberOfClasses (studentClasses) {
      if (!studentClasses) return '-'
      let total = 0
      Object.keys(studentClasses).forEach(id => total += studentClasses[id].length)
      return total
    },
    getClassName (classId) {
      const aClass = this.classes[classId]
      if (!aClass) return
      if (!aClass.date_start)
        return classId.replace(/_/gi," ") //for legacy classes
      else {
        const year = aClass.date_start.split('-')[0]
        const title = this.courses[aClass.course_id].name
        return `${title} ${year} ${aClass.month} ${aClass.time}`
      }
    },
  },
  async mounted () {
    this.student = this.options.student
    await this.getDetails()
  },
}
</script>

<template lang="pug">
  #student-main.modal-main
    .student-container.modal-container
      .title Student details
      .section Student
      .content
        .label Name
        .value {{student.name}}
        .label Birthday
        .value {{student.birthday}}
        .label Class Credits
        .value {{student.class_credits}}
      
        .label Ethnicity
        .value {{student.ethnicity}}
        .label Gender
        .value {{student.gender}}
        .label Gender Self Description
        .value {{student.gender_self_description}}
        .label(v-if='student.user_type.includes("ADULT_STUDENT")') Email
        .value(v-if='student.user_type.includes("ADULT_STUDENT")') {{student.email}}
      .section Classes
      .class-list
        .class(
          v-for='aClass in student.classes'
        ) {{getClassName(aClass)}}

      .section Location
      .content
        .label City
        .value {{student.city}}
        .label State
        .value {{student.state}}
        .label Country
        .value {{student.outside_of_us ? student.country : 'U.S.A.'}}

      .section Guardian
      .content
        .label Name
        .value {{guardian.name}}
        .label Phone #
        .value {{guardian.phone}}
        .label Email
        .value {{guardian.email}}
        .label Agreed to Conduct Policy?
        .value {{guardian.agreed_to_conduct_and_discipline_policy ? "Yes" : "No"}}
        .label Application Status
        .value.uppercase {{guardian.application_status ? guardian.application_status.replace(/_/gi," ").toLowerCase() : ''}}
        .label Payment Plan
        .value {{guardian.payment_plan}}

      template(v-if='student.paperwork && student.paperwork.length')
        .section Emergency Contact
        .content
          .label Name
          .value {{student.paperwork.emergency_contact.name}}
          .label Relationship
          .value {{student.paperwork.emergency_contact.relationshipo}}
          .label Cell Phone
          .value {{student.paperwork.emergency_contact.cell_phone}}
          .label Home Phone
          .value {{student.paperwork.emergency_contact.home_phone}}
          .label Work Phone
          .value {{student.paperwork.emergency_contact.work_phone}}
          .label Email
          .value {{student.paperwork.emergency_contact.email}}

      .section Scholarship
      .content(
        v-for='app, idx in scholarshipApp'
        v-if='scholarshipApp.length'
      ) 
        .label Adults in Household
        .value {{app.adult_count}}
        .label Children in Household
        .value {{app.child_count}}
        .label Annual Income
        .value ${{app.annual_income}}
        .label Total Can Pay
        .value ${{app.can_pay}}
        .label Total # Classes
        .value {{getNumberOfClasses(app.student_classes)}}
        .label.align-top Non-Taxable Incomes
        .value.align-top
          .item(v-for='income in app.non_taxable_incomes') {{income}}
        .label Resolved
        .value {{app.resolved ? "Yes" : "No"}}
        .label Zip Code
        .value {{app.zip_code}}
        .label Created
        .value {{new Date(app.created).toLocaleString()}}
        .spacer(
          v-if='idx+1 < scholarshipApp.length'
        ) ------------------------------
      .simple-content(
        v-else
      ) {{guardian.application_status === 'FULLY_PAID' ? 'Paid tuition in full' : 'No scholarship info.'}}

      .section Paperwork
      .content(
        v-if='student.paperwork'
      )
        .label Comments
        .value {{student.paperwork.emergency_comments}}
        .label Agreed to Media Liability?
        .value {{student.paperwork.media_liability_release ? 'Yes' : 'No'}}
        .label Agreed to Media Use?
        .value {{student.paperwork.media_use_permission ? 'Yes' : 'No'}}
      .notice(
        v-else
      ) Student paperwork not filled out

      .section Misc info
      .content
        .label Created
        .value {{new Date(student.created).toLocaleString()}}
        .label Previous Coding Experience
        .value {{student.previous_coding_experience}}
        .label Wants to Learn Next
        .value {{student.wants_to_learn_next}}
        .label Admin Notes
        .value {{student.note}}
      
      template(
        v-if='invoices.length'
      )
        .section Invoices
        .content.invoice(
          v-for='invoice in invoices'
        )
          .label Amount
          .value ${{invoice.amount}}
          .label Sent
          .value {{new Date(invoice.created).toLocaleString()}}
          .label Message
          .value {{invoice.message}}
          .label Status
          .value.uppercase(
            :class='invoice.status.toLowerCase()'
          ) {{invoice.status.toLowerCase()}}
          template(
            v-if='invoice.status == "PAID"'
          )
            .label Paid
            .value {{new Date(invoice.resolved).toLocaleString()}}
            .label Stripe ID
            .value {{invoice.stripe_charge_id}}
      
      .action
        .button.minor(
          @click='$modals.hide(`student-details`)'
        ) Close
</template>

<style lang="sass" scoped>
  .student-container
    .section
      font-size: 1.2rem
      font-weight: 600
    .content
      display: grid
      grid-template-columns: 7rem 1fr
      grid-row-gap: 0.5rem
      align-items: center
      .label
      .value
        &.uppercase
          text-transform: capitalize
        .item
          margin-bottom: 0.25rem
      .align-top
        align-self: start
      .spacer
        grid-column: span 2
        padding-top: 1rem
      &.invoice
        .value
          &.sent
            color: orange
          &.paid
            color: green
    .class-list
      .class
        text-transform: capitalize
        margin-bottom: 0.5rem
</style>